import { render, staticRenderFns } from "./customCustomer.vue?vue&type=template&id=13b286fb&scoped=true&"
import script from "./customCustomer.vue?vue&type=script&lang=js&"
export * from "./customCustomer.vue?vue&type=script&lang=js&"
import style0 from "./customCustomer.vue?vue&type=style&index=0&id=13b286fb&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b286fb",
  null
  
)

export default component.exports